import NotificationProvider from './NotificationProvider';

export { default as withNotification } from './withNotification';

export default NotificationProvider;
